export const navigationMenuVerticalItemStyles = [
  '[--navigation-menu-vertical-item-font-weight:400]',
  'data-[state=open]:[--navigation-menu-vertical-item-font-weight:600]',
  'border-none',
  'outline-none',
  'bg-none',
  'decoration-[inherit]',
  'cursor-pointer',
  'rounded-md',
  'flex',
  'items-center',
  'p-2',
  'pl-(--navigation-menu-vertical-item-pl)',
  'w-full',
  'text-(--text)',
  'bg-(--background)',
  'disabled:cursor-not-allowed',
  '[text-decoration:unset]',
  'disabled:opacity-30',
  'not-disabled:active:bg-(--background-active)',
  'not-disabled:focus-visible:outline-none',
  'not-disabled:focus-visible:relative',
  'not-disabled:focus-visible:shadow-[var(--color-primary-800)_0px_0px_0px_4px]',
  'not-disabled:focus-visible:shadow-[white_0px_0px_0px_2px]',
  'not-disabled:focus-visible:z-1',
  'not-disabled:hover:bg-(--background-hover)',
  'data-active:bg-(--background-selected)',
  'data-active:text-(--text-selected)',
  'data-active:[--navigation-menu-vertical-item-font-weight:600]'
]
